import React, { useState, useRef, useEffect } from "react";
import { TextField, Chip, Tooltip } from "@mui/material";
import PropTypes from "prop-types";

EmailInput.propTypes = {
  value: PropTypes.string,
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  autoComplete: PropTypes.oneOf(['off', 'no-autocomplete']),
  id: PropTypes.string,
};

export default function EmailInput({ value, setValue, disabled = false, autoComplete = 'off', id = undefined }) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [chip, setChip] = useState(
    value ? { label: value, valid: emailRegex.test(value) } : null
  );
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (!inputValue) setChip(value ? { label: value, valid: emailRegex.test(value) } : null);
  }, [value, inputValue])

  const handleKeyDown = (e) => {
    if (["Enter", " ", ","].includes(e.key)) {
      addEmail(e);
    }
  };

  const addEmail = (e) => {
    e.preventDefault();
    const email = inputValue?.trim() || "";
    if (!email || chip) return;
    const valid = emailRegex.test(email);
    setChip({ label: email, valid });
    setInputValue("");
  }

  const handleDelete = () => {
    setChip(null);
    setValue("");
    inputRef.current?.focus();
  };

  const handleClick = () => {
    setInputValue(value);
    setChip(null);
    inputRef.current?.focus();
  };

  return (
    <TextField
      inputRef={inputRef}
      id="email-input"
      variant="outlined"
      size="small"
      fullWidth
      value={inputValue ?? ""}
      onChange={(e) => {
        setInputValue(e.target.value);
        setValue(e.target.value?.trim());
      }}
      onKeyDown={handleKeyDown}
      onBlur={addEmail}
      disabled={disabled}
      onClick={() => !disabled && handleClick()}
      autoComplete={autoComplete}
      {...(id ? { id } : {})}
      InputProps={{
        readOnly: !!chip,
        startAdornment: chip && (
          <Tooltip title={chip.valid ? "" : "Invalid email address"}>
            <Chip
              label={chip.label}
              onDelete={handleDelete}
              size="small"
              disabled={disabled}
              variant={chip.valid ? "filled" : "outlined"}
              color={chip.valid ? "default" : "error"}
            />
          </Tooltip>
        ),
      }}
    />
  );
}
